export class Customer {
    key: string;
    description: string;
    amount: number;
    date: string;
    active = true;

}
